







































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import { CancelarSolicitacaoParam, TipoOrigemEnum, RequestMessage, PendenciaMensagem, TipoMensagemEnum, TipoDocumentoUpload } from '@/types/_'
import { PendenciaSolicitacao } from '@/types/core'
import { timeout, groupCollectionByField, maskHour } from '@/utils/common'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalBackofficeGerarCobranca extends Vue {
  $refs!: {
    gerarCobranca: any,
    pendencia: any,
    refConfirmarPendencia: any,
  }

  loadClose: boolean = false
  loadCancelamento: boolean = false
  modalPendencia: boolean = false
  loadPendencia: boolean = false
  loadHistorico: boolean = false
  loadComentarios: boolean = false
  loadNextStep: boolean = false
  loadConfirmar: boolean = false
  loadRetornar: boolean = false
  loadBackStep: boolean = false
  modalConfirmarPendencia: boolean = false
  loadClosePedencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadUpload: boolean = false
  loadConfirmarPendencia: boolean = false
  loadMensagem: boolean = false
  mensagem: string = ''
  inputFiles: any[] = []

  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()

  get hospitalBlumenau() {
    const { solicitacao } = this.getBackofficeGlobalStore
    if (solicitacao && solicitacao.hospital && !!solicitacao.hospital.nome) return solicitacao.hospital.nome === 'Hospital Santa Catarina Blumenau'
    return false
  }

  get getOrcamentoAnexo() {
    return {
      pedidoMedico: true,
      laudo: true,
      cotacaoOpme: true,
      laudoAnestesista: true,
      anexoOperadora: true,
      resumo: true,
    }
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get loadingBackStep() {
    return this.loadBackStep
  }

  set loadingBackStep(value: boolean) {
    this.loadBackStep = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingRetornar() {
    return this.loadRetornar
  }

  set loadingRetornar(val: boolean) {
    this.loadRetornar = val
  }

  get getDisplayPendencia() {
    return {
      nomePaciente: this.getBackofficeGlobalStore.solicitacao.pacienteNome,
      nomeMedico: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome,
    }
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingNextStep() {
    return this.loadNextStep
  }

  set loadingNextStep(value: boolean) {
    this.loadNextStep = value
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeOrcamentoStore() {
    return getModule(BackofficeOrcamentoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get showModalGerarCobranca() {
    const show = this.getBackofficeGlobalStore.modal.gerarCobranca
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalGerarCobranca(val: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'gerarCobranca', value: val })
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  async closeModal() {
    this.loadingClose = true
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getBackofficeGlobalStore.desbloquearSolicitacao(solicitacaoId)
    await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    this.getPendenciaStore.clearPendencia()
    this.getPendenciaStore.setModalConfirmar(false)
    this.showModalConfirmarPendencia = false
    this.getBackofficeGlobalStore.clearSolicitacao()
    this.getBackofficeGlobalStore.clearOrcamentoPagamento()
    if (this.$refs.gerarCobranca) this.$refs.gerarCobranca.$refs.gerarCobrancaInformarPagamentoForm.resetValidation()
    solicitacaoId = ''
    this.showModalGerarCobranca = false
    this.loadingClose = false
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeout(400)
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'orcamento',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  async addPendenciaMensagem(mensagem: string) {
    await timeout(400)
    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: mensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    // @ts-ignore
    this.$refs.pendencia.clearMensagem()
  }

  async addPendenciaFile(documentoId, url, nomeArquivo, tipoMensagem) {
    const time = moment().format('YYYY-MM-DDTHH:mm')

    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem,
      texto: '',
      documentoId,
      url,
      nomeArquivo,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
  }

  async closeModalCancelamento() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.closeModal()
    EventBus.$emit('clearLoadingRequest')
  }

  async confirmar() {
    this.loadingConfirmar = true

    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingConfirmar = false
      return
    }

    if (!this.$refs.gerarCobranca.$refs.gerarCobrancaInformarPagamentoForm.validate()) {
      this.loadingConfirmar = false
      return
    }

    const response = await this.getBackofficeGlobalStore.backofficeOrcamentoPagamento()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao gerar a cobrança.', icon: 'warning', color: '#C62828' })
      this.loadingConfirmar = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Cobrança gerada com sucesso.', icon: 'done', color: '#2E7D32' })
    this.loadingConfirmar = false
    await this.closeModal()
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeout(200)
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeout(200)
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeOrcamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar a pendência.', icon: 'warning', color: '#C62828' })
    }

    await timeout(200)
    this.loadingConfirmarPendencia = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeout(200)

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }
  /** Fim - Pendência */

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_orcamento')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
